/** Local-time render of an ISO timestamp ("—" when absent/unparseable). */
export function when(iso: string | null | undefined): string {
  if (!iso) return "—";
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? iso : date.toLocaleString();
}

/** Human wall time between two ISO timestamps ("—" when either is missing). */
export function duration(
  start: string | null | undefined,
  end: string | null | undefined,
): string {
  if (!start || !end) return "—";
  const ms = new Date(end).getTime() - new Date(start).getTime();
  if (!Number.isFinite(ms) || ms < 0) return "—";
  const s = Math.round(ms / 1000);
  if (s >= 3600)
    return `${Math.floor(s / 3600)}h ${Math.floor((s % 3600) / 60)}m`;
  if (s >= 60) return `${Math.floor(s / 60)}m ${s % 60}s`;
  return `${s}s`;
}

/** Human duration from an API-provided wall-clock count. */
function elapsed(seconds: number | null | undefined): string {
  if (seconds === null || seconds === undefined || seconds < 0) return "—";
  const rounded = Math.round(seconds);
  if (rounded >= 3600) {
    return `${Math.floor(rounded / 3600)}h ${Math.floor((rounded % 3600) / 60)}m`;
  }
  if (rounded >= 60) {
    return `${Math.floor(rounded / 60)}m ${rounded % 60}s`;
  }
  return `${rounded}s`;
}

/** Human age from an ISO timestamp to a deterministic/current clock. */
export function liveElapsed(
  start: string | null | undefined,
  nowMs = Date.now(),
): string {
  if (!start) return "—";
  const startMs = new Date(start).getTime();
  if (!Number.isFinite(startMs) || !Number.isFinite(nowMs) || nowMs < startMs) {
    return "—";
  }
  return elapsed((nowMs - startMs) / 1000);
}
